import React, { Component } from "react"
import logo from '../../../images/logo-rt132-2024.png';
import { Link } from "react-router-dom";

import MainMenu from "../Menu/MainMenu"
import Hamburger from "../Hamburger/Hamburger"

class Header extends Component {

  componentDidMount() {
    window.onscroll = () => this._handleScroll()
  }

  _handleScroll() {
    if (document.documentElement.scrollTop > 0) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  }

  constructor(props) {
    super(props);

    this._handleScroll = this._handleScroll.bind(this);
    this.state = {
      scrolled: false
    };
  }

  render() {

    const dataPrimary = this.props.primary
    const dataHamburger = this.props.hamburger

    return (
      <nav onScroll={this._handleScroll} className={`w-full h-auto py-10 top-0 z-50 ease-in-out duration-300 fixed ${this.state.scrolled === true ? "bg-white pt-6 pb-6" : ""}`}>
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8">
          <div className="w-full flex items-center xs:px-4">
            <div className="w-1/6 xs:w-16 lg:w-24">
              <Link to="/"><img src={logo} alt="logo"/></Link>
            </div>
            <div className="w-5/6 hidden lg:block">
              <MainMenu dataPrimary={dataPrimary}/>
            </div>
            <div className="w-5/6 block lg:hidden">
              <Hamburger dataHamburger={dataHamburger}/>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Header
